import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { DeleteIcon } from '@treams/treams-icons';
import { Button } from '@treams/treams-ui';

type Variables = { input: { id: string } };
type Mutation = (options: { variables: Variables }) => [() => Promise<any>, { loading: boolean }];

export default function ArchiveButton<T extends { id: string; isArchived: boolean }>(props: {
	item: T;
	useArchive: Mutation;
	useRestore: Mutation;
}) {
	const theme = useTheme();

	const options = { variables: { input: { id: props.item.id } } };
	const [archive, { loading: archiveLoading }] = props.useArchive(options);
	const [restore, { loading: restoreLoading }] = props.useRestore(options);

	const { t } = useTranslation();

	const toggleArchived = async () => {
		if (props.item.isArchived) {
			await restore();
		} else {
			await archive();
		}
	};

	return (
		<Button
			title={t(`goals.button.${!props.item.isArchived ? 'archive' : 'restore'}`)}
			onClick={toggleArchived}
			icon={<DeleteIcon />}
			type="secondary"
			loading={archiveLoading || restoreLoading}
		/>
	);
}
